import * as React from "react";
import { ErrorMessage } from "./ErrorMessage";
import { IErrorSummary, IFormErrors } from "../Models/FeedbackForm";

export const ErrorSummary = ({brandStyle, formErrors, focusHandler}: IErrorSummary) => {
  return (
    <>
      {Object.keys(formErrors).map((fieldName, i) => {
        if (formErrors[fieldName as keyof IFormErrors] === true) {
          return (
            <>
                <li><ErrorMessage brandStyle={brandStyle} fieldName={fieldName} focusHandler = {focusHandler} /></li>
            </>
          );
        } else {
          return;
        }
      })}
    </>
  );
};
